import { SearchBrowseParams } from '@aibees/shared/definition';
import { encodeQueryParamValues } from '@aibees/shared/utils';

export function buildSearchParamsDraft(
  field: string,
  fields: string[],
  values: string[],
  params: Partial<SearchBrowseParams>,
  singleEntry?: boolean
) {
  return {
    ...fields?.reduce(
      (acc, x) => ({ ...acc, [x]: !singleEntry ? params[x] : undefined }),
      {}
    ),
    ...{ [field]: encodeQueryParamValues(values, undefined) },
  };
}
